



import React, { useState } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CustomText, { textStyles } from "../../components/CustomText";
import { useTranslation } from "react-i18next";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";



// Icon imports
import AgricultureIcon from "@mui/icons-material/Agriculture";
import HandymanIcon from "@mui/icons-material/Handyman";
import EngineeringIcon from "@mui/icons-material/Engineering";
import FoundationIcon from "@mui/icons-material/Foundation";
import ConstructionIcon from "@mui/icons-material/Construction";
import BuildIcon from "@mui/icons-material/Build";
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import NaturePeopleIcon from "@mui/icons-material/NaturePeople";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import ParkIcon from "@mui/icons-material/Park";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SailingIcon from "@mui/icons-material/Sailing";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import OilBarrelIcon from "@mui/icons-material/OilBarrel";
import FormatPaintIcon from "@mui/icons-material/FormatPaint";
import PlumbingIcon from "@mui/icons-material/Plumbing";
import TrainIcon from "@mui/icons-material/Train";
import SolarPowerIcon from "@mui/icons-material/SolarPower";
import RoofingIcon from "@mui/icons-material/Roofing";
import ExploreIcon from "@mui/icons-material/Explore";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";

const industries = [
  { title: "Agriculture", icon: <AgricultureIcon /> },
  { title: "Carpenters", icon: <HandymanIcon /> },
  { title: "Civil Construction", icon: <EngineeringIcon /> },
  { title: "Concrete & Masonry", icon: <FoundationIcon /> },
  { title: "Construction", icon: <ConstructionIcon /> },
  { title: "Contractors", icon: <BuildIcon /> },
  { title: "Electricians", icon: <ElectricalServicesIcon /> },
  { title: "Engineers", icon: <PrecisionManufacturingIcon /> },
  { title: "Environmental Services", icon: <NaturePeopleIcon /> },
  { title: "HVAC", icon: <AcUnitIcon /> },
  { title: "Landscaping", icon: <ParkIcon /> },
  { title: "Logistics", icon: <LocalShippingIcon /> },
  { title: "Maritime", icon: <SailingIcon /> },
  { title: "Mining", icon: <TravelExploreIcon /> },
  { title: "Oil & Energy", icon: <OilBarrelIcon /> },
  { title: "Painters", icon: <FormatPaintIcon /> },
  { title: "Plumbers", icon: <PlumbingIcon /> },
  { title: "Railroad", icon: <TrainIcon /> },
  { title: "Renewables", icon: <SolarPowerIcon /> },
  { title: "Roofers", icon: <RoofingIcon /> },
  { title: "Surveyors", icon: <ExploreIcon /> },
  { title: "Transportation", icon: <DirectionsBusIcon /> },
  { title: "Trucking", icon: <LocalShippingIcon /> },
  { title: "Utilities", icon: <SettingsInputComponentIcon /> },
  { title: "Waste Management", icon: <DeleteSweepIcon /> },
];

const Workers = () => {
  const CARDS_PREVIEW_COUNT = 6;

    const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.down("sm","md"));
    const [showAll, setShowAll] = useState(false);
    const visibleIndustries = isMobile && !showAll ? industries.slice(0, CARDS_PREVIEW_COUNT) : industries;

  return (
    <Box sx={{ px: 3, py: 6, mt:8,textAlign: "center" }}>
     <CustomText
                 style={{
                   ...textStyles.h1,
                   marginBottom: isMobile ? "0rem" : "1rem",
                   marginTop: isMobile ? "0rem" : "1rem",
                   fontSize: isMobile ? "30px" : "36px",
                   textAlign: "center",
     
     
     
                 }}
               >
        {/* Field Workers */}
        {t("workers.title")}
               </CustomText>
  <CustomText
            style={{
              ...textStyles.body1,
              color: "#868282",
               maxWidth: "910px",
              margin: "0 auto",
              marginTop: "10px",
              textAlign: "left",
              fontSize: "24px",
              lineHeight: "120%",
              textAlign:"center"
            }}
          >
               {/* We support all types of field services businesses. Click on any industry below to learn more. */}
          {t("workers.description")}
          </CustomText>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: { xs: 2, md: 3 },
          px: {
            xs: 1,   // Mobile
            sm: 5,   // Tablet
            lg: 28,  // Desktop and larger
          },
          mt:3,
        }}
      >
        {visibleIndustries.map((item, index) => (
          <Box
            key={index}
            sx={{
              width: { xs: "46%", md: "30%" },
              minHeight: { xs: 100, md: 120 },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid  #DFDFDF",
              borderRadius: "12px",
              p: { xs: 1, md: 2 },
              cursor:"pointer",
              transition: "0.3s",
               "&:hover": {
      transform: "scale(1.03)",
    },
            }}

          >
            <Box sx={{ color: "#1976d2", mb: 0.2 }}>
              {item.icon}
            </Box>
            <Typography  sx={{fontWeight:700,color:"#003149",fontSize:{ xs: "13px", md: "18px" },textAlign:"center"}}>
                {/* {item.title} */}
    {t(`workers.industries.${item.title}`)}
            </Typography>
          </Box>
        ))}
      </Box>

      {isMobile && industries.length > CARDS_PREVIEW_COUNT && (
        <Box
          onClick={() => setShowAll((prev) => !prev)}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
            mt: 4,
            cursor: "pointer",
            color: "#1976d2",
            fontWeight: 600,
            fontSize: "16px",
            userSelect: "none",
            "&:hover": { opacity: 0.75 },
          }}
        >
          <Typography sx={{ fontWeight: 600, fontSize: "16px", color: "inherit" }}>
            {showAll ? t("common.viewLess") : t("common.viewMore")}
          </Typography>
          <KeyboardArrowDownIcon
            sx={{
              transition: "transform 0.3s",
              transform: showAll ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default Workers;
